import { render } from "./registerTab.vue?vue&type=template&id=e53c82ee"
import script from "./registerTab.vue?vue&type=script&lang=ts"
export * from "./registerTab.vue?vue&type=script&lang=ts"

import "./registerTab.vue?vue&type=style&index=0&id=e53c82ee&lang=scss"
script.render = render

export default script